import XLSX from 'xlsx';
import moment from 'moment';


/* export default function exportResults(businessPlan) {
	const workbook = XLSX.utils.book_new();

	const choicesData = getChoicesData(businessPlan);
	const choiceWorksheet = XLSX.utils.aoa_to_sheet(choicesData);
	XLSX.utils.book_append_sheet(workbook, choiceWorksheet, 'choices');

	const resultsData = getResultsData(businessPlan);
	const resultsWorksheet = XLSX.utils.aoa_to_sheet(resultsData);
	XLSX.utils.book_append_sheet(workbook, resultsWorksheet, 'results');

	XLSX.writeFile(
		workbook,
		`bp-${businessPlan.submission}-${moment(
			businessPlan.submittedAt || Date.now()
		).format('DD-MM-YYYY-hh-mm-ss')}.xlsx`
	);
}

const getValues = ( businessPlan, arr, kind) => arr.map(({ id, label, crossYears }) => [
	label,
	...(crossYears? [businessPlan.variables[kind][id].value]:
		businessPlan.variables[kind][id].map(v => v.value))
])

const getChoicesData = (businessPlan) => {
	return [
		['Sales', 'Year 1', 'Year 2', 'Year 3'],
		[],
		...getValues(businessPlan, sales, 'sales' ),
		[],
		[],
		['Production', 'Year 1', 'Year 2', 'Year 3'],
		[],
		...getValues(businessPlan, production, 'production' ),
		[],
		[],
		['Procurement', 'Year 1', 'Year 2', 'Year 3'],
		[],
		...getValues(businessPlan, procurement, 'procurement' ),
		[],
		[],
	]
}

const sales = [
	{ id: 'price', label: 'Selling Price' },
	{ id: 'daysReceivable', label: 'Days In Receivables' },
	{ id: 'marketingExpenses', label: 'Marketing Expenses' },
	{ id: 'supplierBottleChoice', label: 'Bottle Model', crossYears: true },
]

const production = [
	{ id: 'machines', label: 'Number of production lines', crossYears: true },
	{ id: 'machineProductionCapacityUsageQuota', label: 'Production line capacity usage (%)' },
	{ id: 'outsourcingQuota', label: 'Outsourced production capacity (%)' },
	{ id: 'qualityCheckPersonel', label: 'Quality' },
	{ id: 'recyclingAndWasteManagement', label: 'Recycling And Waste Management' },
	{ id: 'qualityMaintenance', label: 'Quality Maintenance' },
	{ id: 'juiceTaster', label: 'Juice Taster' },
	{ id: 'chemicalExpert', label: 'Chemical Expert' },
]

const procurement = [
	{ id: 'supplierBottleChoice', label: 'Bottle Model', crossYears: true },
	{ id: 'supplierAppleChoice', label: 'Apple Supplier', crossYears: true },
]


const getResultsData = (businessPlan) => {
	return [
		['Income Statement', 'Year 1', 'Year 2', 'Year 3'],
		[],
		...incomeStatement.map(({ id, label }) => [
			label,
			...businessPlan.variables.incomeStatement[id].map(v => parseInt(v.value))
		]),
		[],
		[],
		['Balance Sheet', 'Year 1', 'Year 2', 'Year 3'],
		[],
		...balanceSheet.map(({ id, label }) => [
			label,
			...businessPlan.variables.balanceSheet[id].map(v => parseInt(v.value))
		]),
		[],
		[],
		['Cash Flow Statement', 'Year 1', 'Year 2', 'Year 3'],
		[],
		...cashFlowStatement.map(({ id, label }) => [
			label,
			...businessPlan.variables.cashFlowStatement[id].map(v =>
				parseInt(v.value)
			)
		])
	];
} */

const incomeStatement = [
	{ id: 'revenues', label: 'Revenues', type: 'array' },
	{ id: 'directMaterialCosts', label: '- Direct material costs', type: 'array' },
	{
		id: 'outsourcedProductionCosts',
		label: '- Total outsourced production costs',
		type: 'array'
	},
	{ id: 'sellingCommissions', label: '- Selling commisions', type: 'array' },
	{ id: 'contributionMargin', label: 'Contribution margin', type: 'array' },
	{ id: 'productionOverheads', label: '- Production overheads', type: 'array' },
	{ id: 'marketingExpenses', label: '- Marketing expenses', type: 'array' },
	{ id: 'sellingExpenses', label: '- Selling expenses', type: 'array' },
	{
		id: 'generalAndAdministrativeExpenses',
		label: '- General and administrative expenses',
		type: 'array'
	},
	{ id: 'operatingIncome', label: 'Operating income (EBIT)', type: 'array' },
	{
		id: 'interestExpensesLongTerm',
		label: '- Interest expenses on long-term debts',
		type: 'array'
	},
	{
		id: 'interesetExpensesOnBankOverdraft',
		label: '- Interest expenses on short-term debts (line of credit)',
		type: 'array'
	},
	{ id: 'preTaxIncomeWithShortTerm', label: 'Pre-tax income', type: 'array' },
	{ id: 'taxes', label: 'Taxes', type: 'array' },
	{ id: 'netIncome', label: 'Net income', type: 'array' }
];
const balanceSheet = [
	{ id: 'cash', label: 'Cash', type: 'array' },
	{ id: 'accountReceivables', label: 'Account receivables', type: 'array' },
	{
		id: 'totalRawMaterialInventory',
		label: 'Raw material inventory',
		type: 'array'
	},
	{
		id: 'finishedGoodsInventory',
		label: 'Finished goods inventory',
		type: 'array'
	},
	{ id: 'totalCurrentAssets', label: 'Total current assets', type: 'array' },
	{ id: 'netFixedAssets', label: 'Net fixed assets', type: 'array' },
	{ id: 'totalAssets', label: 'Total assets', type: 'array' },
	{ id: 'accountPayables', label: 'Account payables (total)', type: 'array' },
	{ id: 'shortTermDebts', label: 'Short-term debt', type: 'array' },
	{ id: 'currentLiabilities', label: 'Current liabilities', type: 'array' },
	{ id: 'longTermDebt', label: 'Long-term debt', type: 'array' },
	{ id: 'totalLiabilities', label: 'Total liabilities', type: 'array' },
	{ id: 'equity', label: "Common stockholders' equity", type: 'array' },
	{
		id: 'retainedEarnings',
		label: 'Reserves (Retained earnings)',
		type: 'array'
	},
	{ id: 'netIncome', label: 'Net income', type: 'array' },
	{ id: 'totalEquity', label: 'Total equity', type: 'array' },
	{
		id: 'totalLiabilitiesAndEquity',
		label: 'Total liabilities and equity',
		type: 'array'
	}
];
const cashFlowStatement = [
	{ id: 'netIncome', label: 'Net income', type: 'array' },
	{
		id: 'fixedAssetsDepreciation',
		label: 'Depreciation (total)',
		type: 'array'
	},
	{ id: 'inventoryDelta', label: '+ Δ inventory', type: 'array' },
	{ id: 'receivablesDelta', label: '+ Δ receivables', type: 'array' },
	{ id: 'payablesDelta', label: '- Δ payables', type: 'array' },
	{
		id: 'cashFlowFromOperations',
		label: 'Cash flow from operations (CFO)',
		type: 'array'
	},
	{ id: 'capitalExpenditures', label: '-CAPEX', type: 'array' },
	{ id: 'longTermDebtDelta', label: '+ Long-term debt', type: 'array' },
	{ id: 'shortTermDebtsDelta', label: '+ Short-term debt', type: 'array' },
	{ id: 'equityDelta', label: "+ Common stockholders' equity", type: 'array' },
	{ id: 'totalCashFlow', label: 'Total cash', type: 'array' }
];

const decisions = [
	//Sales
	///SalesPrograms
	{ id: 'price', label: 'Selling Price', type: 'array', category: 'sales' },	
	{ id: 'daysReceivable', label: 'Days In Receivable', type: 'array', category: 'sales' },	
	{ id: 'marketingExpenses', label: 'Marketing Expenses', type: 'array', category: 'sales' },	
	
	//Production
	///Internally
	{ id: 'machines', label: 'Number of Production Line', type: 'number', category: 'production' },
	{ id: 'machineProductionCapacityUsageQuota', label: 'Production Line Capacity Usage', type: 'array', category: 'production' },
	///Externally
	{ id: 'outsourcingQuota', label: 'Outsourced production capacity', type: 'array', category: 'production' },
	///Quality Check
	{ id: 'qualityCheckPersonel', label: 'Quality Check Personel', type: 'array', category: 'production' },	
	{ id: 'recyclingAndWasteManagement', label: 'Recycling and Waste Management', type: 'array', category: 'production' },	
	{ id: 'qualityMaintenance', label: 'Quality Maintenance', type: 'array', category: 'production' },	
	{ id: 'juiceTaster', label: 'Juice Taster', type: 'array', category: 'production' },
	{ id: 'chemicalExpert', label: 'Chemical Expert', type: 'array', category: 'production' },
	
	//Procurement
	///Supplier
	{ id: 'supplierBottleChoice', label: 'Supplier Bottle Choice', type: 'number', category: 'sales' },	
	{ id: 'supplierAppleChoice', label: 'Supplier Apple Choice', type: 'number', category: 'procurement' }
	
	//Decisions di test, al momento non sono richieste
	/* { id: 'supposedPrice', label: 'Supposed Price', type: 'number', category: 'sales' },	
	{ id: 'supposedMarketingExpenses', label: 'Supposed Marketing Expenses', type: 'number', category: 'sales' },	
	{ id: 'supposedDaysReceivable', label: 'Supposed Days Receivable', type: 'number', category: 'sales' },
	{ id: 'supposedQuality', label: 'Supposed Quality', type: 'number', category: 'sales' },*/	
]


export default function exportResults(businessPlan) {
	const config = {
		incomeStatement,
		balanceSheet,
		cashFlowStatement,
	}
	const data = getDataBusinessPlan(businessPlan, config);
	const worksheet = XLSX.utils.aoa_to_sheet(data);
	const new_workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(new_workbook, worksheet, 'results');
	XLSX.writeFile(
		new_workbook,
		`bp-${businessPlan.submission}-${moment(
			businessPlan.submittedAt || Date.now()
		).format('DD-MM-YYYY-hh-mm-ss')}.xlsx`
	);
}

export function exportAllBusinessPlansResults(businessPlans) {
	const new_workbook = XLSX.utils.book_new();
	const config = {
		incomeStatement,
		balanceSheet,
		cashFlowStatement,
		decisions
	}
	for(let x=0; x<businessPlans.length; x++){
		const businessPlan = businessPlans[x];
		const data = getDataBusinessPlan(businessPlan, config);
		const worksheet = XLSX.utils.aoa_to_sheet(data);
		XLSX.utils.book_append_sheet(new_workbook, worksheet, `submission ${x + 1}`);
	}
	XLSX.writeFile(
		new_workbook,
		'businessPlans.xlsx'
	);
}

const getDecisionsData = (data, decisions) => {
	return decisions.map(decision => {
		const { type, label, category, id } = decision;
		const decisionValues = data[category][id];
		
		switch (type) {
		case 'array': {
			return [label, decisionValues[0].value, decisionValues[1].value, decisionValues[2].value];
		}
		case 'number': {
			return [label, '', decisionValues.value, '']
		}
		}
	})
}


const getDataBusinessPlan = (businessPlan, config) => {
	const data = [
		['Income Statement', 'Year 1', 'Year 2', 'Year 3'],
		[],
		...config.incomeStatement.map(({ id, label }) => [
			label,
			...businessPlan.variables.incomeStatement[id].map(v => parseInt(v.value))
		]),
		[],
		[],
		['Balance Sheet', 'Year 1', 'Year 2', 'Year 3'],
		[],
		...config.balanceSheet.map(({ id, label }) => [
			label,
			...businessPlan.variables.balanceSheet[id].map(v => parseInt(v.value))
		]),
		[],
		[],
		['Cash Flow Statement', 'Year 1', 'Year 2', 'Year 3'],
		[],
		...config.cashFlowStatement.map(({ id, label }) => [
			label,
			...businessPlan.variables.cashFlowStatement[id].map(v =>
				parseInt(v.value)
			)
		]),
		[]
	]
	if(config.decisions){
		data.push(
			[],
			['Decisions', 'Year 1', 'Year 2', 'Year 3'],
			[],
			...getDecisionsData(businessPlan.variables, config.decisions),
			[]
		)
	}
	return data;
}